module.exports = __webpack_public_path__ + "img/bgsecond.38c170ce.png";